import { LitElement, css, html } from 'lit'

export class DzSpoiler extends LitElement {
    static get properties() {
        return {
            state: { type: String, reflect: true },
            store: { type: String},
        }
    }

    connectedCallback() {
        super.connectedCallback()
        this.state = window.localStorage.getItem(this.store)
    }

    render() {
        return html`
            <slot name="header" @click="${this.changeState}"></slot>
            <slot name="body"></slot>
        `
    }

    updated() {
        let head = this.renderRoot.children[0].assignedElements({flatten: true})[0]
        let head_height = head.getBoundingClientRect().height 
        if (this.state == "closed") {
            this.style.height = `${head_height}px`
        } else {
            let body = this.renderRoot.children[1].assignedElements({flatten: true})[0]
            let body_height = body.getBoundingClientRect().height
            this.style.height = `${head_height + body_height}px`
        }
    }

    changeState() {
        if (this.state == "open") {
            this.state = "closed"
            window.localStorage.setItem(this.store, "closed")
        } else {
            this.state = "open"
            window.localStorage.setItem(this.store, "open")
        }
    }

    static get styles() {
        return css`
            :host {
                display: block;
                transition: 0.2s;
                overflow: hidden;
            }
        `
    }
}

window.customElements.define('dz-spoiler', DzSpoiler)